export default function (
  state = { taxonomyTree: {}, taxonomySuggestions: {}, taxonomyNodeLookup: {} },
  action
) {
  switch (action.type) {
    case "SET_TAXONOMY_TREE":
      return Object.assign({}, state, {
        taxonomyTree: action.taxonomyTree,
      });
    case "SET_TAXONOMY_SUGGESTIONS":
      return Object.assign({}, state, {
        taxonomySuggestions: action.taxonomySuggestions,
      });
    case "SET_TAXONOMY_NODELOOKUP":
      return Object.assign({}, state, {
        taxonomyNodeLookup: action.taxonomyNodeLookup,
      });
    default:
      return state;
  }
}
